// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesItemCommon-messagesItemsContainer-SAVrU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
}

.MessagesItemCommon-displayFlexReverse-fCvp2 {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
        -ms-flex-direction: row-reverse;
            flex-direction: row-reverse;
}

.MessagesItemCommon-messagesItemsWrapper-djIfi {
    position: relative;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    z-index: 2;
}

.MessagesItemCommon-messagesItemsImgContainer-Nhzcl {
    position: relative;
    width: 62px;
    height: 62px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    border-radius: 50%;
    background: var(--primary-gray-bg);
}

.MessagesItemCommon-messagesItemsDefaultImgContainer-OB9yX {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.MessagesItemCommon-messagesItemsImg-xPEdJ {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
}

.MessagesItemCommon-messagesItemsDefaultImg-C_vSq {
    width: 32px;
    height: 32px;
}

.MessagesItemCommon-messagesItemsInfoContainer-H_OLW {
    padding: 12px 18px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    position: relative;
    z-index: 1;
}

.MessagesItemCommon-messagesItemsInfoContainer-H_OLW::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    z-index: -1;
}

.MessagesItemCommon-messagesItemsInfoContainer-H_OLW::after {
    content: '';
    position: absolute;
    top: 0px;
    width: 40px;
    height: 40px;
    z-index: -1;
}

@media (max-width: 575px) {
    .MessagesItemCommon-messagesItemsContainer-SAVrU {
        gap: 6px;
    }

    .MessagesItemCommon-messagesItemsImgContainer-Nhzcl {
        width: 30px;
        height: 30px;
    }

    .MessagesItemCommon-messagesItemsInfoContainer-H_OLW {
        padding: 8px 12px;
    }

    .MessagesItemCommon-messagesItemsInfoContainer-H_OLW::after {
        width: 20px;
        height: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatMessages/MessagesItem/MessagesItemCommon/MessagesItemCommon.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;AACb;;AAEA;IACI,8BAA2B;IAA3B,8BAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,oBAAc;QAAd,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;IACd,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,MAAM;IACN,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAGA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".messagesItemsContainer {\n    display: flex;\n    gap: 12px;\n}\n\n.displayFlexReverse {\n    flex-direction: row-reverse;\n}\n\n.messagesItemsWrapper {\n    position: relative;\n    flex-shrink: 0;\n    z-index: 2;\n}\n\n.messagesItemsImgContainer {\n    position: relative;\n    width: 62px;\n    height: 62px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: var(--primary-gray-bg);\n}\n\n.messagesItemsDefaultImgContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.messagesItemsImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n}\n\n.messagesItemsDefaultImg {\n    width: 32px;\n    height: 32px;\n}\n\n.messagesItemsInfoContainer {\n    padding: 12px 18px;\n    flex-grow: 1;\n    position: relative;\n    z-index: 1;\n}\n\n.messagesItemsInfoContainer::before {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 0;\n    z-index: -1;\n}\n\n.messagesItemsInfoContainer::after {\n    content: '';\n    position: absolute;\n    top: 0px;\n    width: 40px;\n    height: 40px;\n    z-index: -1;\n}\n\n\n@media (max-width: 575px) {\n    .messagesItemsContainer {\n        gap: 6px;\n    }\n\n    .messagesItemsImgContainer {\n        width: 30px;\n        height: 30px;\n    }\n\n    .messagesItemsInfoContainer {\n        padding: 8px 12px;\n    }\n\n    .messagesItemsInfoContainer::after {\n        width: 20px;\n        height: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagesItemsContainer": `MessagesItemCommon-messagesItemsContainer-SAVrU`,
	"displayFlexReverse": `MessagesItemCommon-displayFlexReverse-fCvp2`,
	"messagesItemsWrapper": `MessagesItemCommon-messagesItemsWrapper-djIfi`,
	"messagesItemsImgContainer": `MessagesItemCommon-messagesItemsImgContainer-Nhzcl`,
	"messagesItemsDefaultImgContainer": `MessagesItemCommon-messagesItemsDefaultImgContainer-OB9yX`,
	"messagesItemsImg": `MessagesItemCommon-messagesItemsImg-xPEdJ`,
	"messagesItemsDefaultImg": `MessagesItemCommon-messagesItemsDefaultImg-C_vSq`,
	"messagesItemsInfoContainer": `MessagesItemCommon-messagesItemsInfoContainer-H_OLW`
};
module.exports = ___CSS_LOADER_EXPORT___;
